const initialState = {
  users: {
    isSignedIn:false,
    uid:"",
    username:"",
    books:[],
    pages:0
  }
}

export default initialState